module.exports = __webpack_public_path__ + "img/cSharp.c3ceaf85.svg";